import React, { useEffect, useRef } from 'react';
var SnippylyRecorderControlPanel = function (props) {
    var mode = props.mode, panelId = props.panelId, onRecordedData = props.onRecordedData;
    var ref = useRef();
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onRecordedData', function (event) {
                if (onRecordedData) {
                    onRecordedData(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-recorder-control-panel", { ref: ref, mode: mode, "panel-id": panelId }));
};
export default SnippylyRecorderControlPanel;
